
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tutors",
      function () {
        return require("private-next-pages/tutors/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tutors"])
      });
    }
  